import type { SVGProps } from 'react';

const SvgDevelopers = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="m9.82 14.35-4.4 4.4a.75.75 0 0 0 0 1.06l4.4 4.4 1.06-1.06-3.87-3.87 3.87-3.87zM22.18 14.35l-1.06 1.06 3.87 3.87-3.87 3.87 1.06 1.06 4.4-4.4a.75.75 0 0 0 0-1.06zM13.639 26.454l3.256-14.345 1.463.332-3.256 14.345z"
    />
    <path
      fill={props.color}
      d="M29.02.36H2.98C1.46.36.23 1.59.23 3.11v25.78c0 1.52 1.23 2.75 2.75 2.75h26.04c1.52 0 2.75-1.23 2.75-2.75V3.11c0-1.52-1.23-2.75-2.75-2.75M2.98 1.86h26.04c.69 0 1.25.56 1.25 1.25v3.85H1.73V3.11c0-.69.56-1.25 1.25-1.25m26.04 28.28H2.98c-.69 0-1.25-.56-1.25-1.25V8.46h28.54v20.43c0 .69-.56 1.25-1.25 1.25"
    />
    <path fill={props.color} d="M4.42 3.74h2.95v1.5H4.42zM9.72 3.74h2.95v1.5H9.72z" />
  </svg>
);

export default SvgDevelopers;
